import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "disabled", "tabIndex", "isLoading", "onClick", "loadingSize", "variant", "theme"];
import React from 'react';
import PropTypes from 'prop-types';
import withTheme from '../theme/withTheme';
import CircularLoading from '../CircularLoading';
import { Button as ButtonElement } from './styles';
var Button = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    disabled = _ref.disabled,
    tabIndex = _ref.tabIndex,
    isLoading = _ref.isLoading,
    onClick = _ref.onClick,
    loadingSize = _ref.loadingSize,
    variant = _ref.variant,
    theme = _ref.theme,
    props = _objectWithoutProperties(_ref, _excluded);
  var loadingColor = theme.button[variant].color;
  return /*#__PURE__*/React.createElement(ButtonElement, _extends({
    ref: ref,
    variant: variant,
    disabled: disabled,
    tabIndex: disabled ? -1 : tabIndex,
    isLoading: isLoading,
    onClick: isLoading ? undefined : onClick,
    theme: theme
  }, props), isLoading ? /*#__PURE__*/React.createElement(CircularLoading, {
    size: loadingSize,
    color: loadingColor
  }) : children);
});
process.env.NODE_ENV !== "production" ? Button.propTypes = {
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  loadingSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  size: PropTypes.oneOf(['big', 'medium', 'small']),
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  type: PropTypes.oneOf(['submit', 'reset', 'button']),
  variant: PropTypes.oneOf(['default', 'error', 'outlined', 'primary', 'success'])
} : void 0;
Button.defaultProps = {
  disabled: false,
  isLoading: false,
  loadingSize: 20,
  size: 'medium',
  tabIndex: 0,
  type: 'button',
  variant: 'default'
};
export default withTheme(Button);